module.exports = __webpack_public_path__ + "img/mimoz-draw.7d4ad58a.jpg";